import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { getRootFromIndexLink } from "@/onload";
import { withPrefix } from "@/utils/redirect";
import { errorCount as jobStatesSummaryErrorCount, jobCount as jobStatesSummaryJobCount, numTerminal, okCount as jobStatesSummaryOkCount, runningCount as jobStatesSummaryRunningCount, } from "./util";
import ExternalLink from "../ExternalLink.vue";
import HelpText from "../Help/HelpText.vue";
import InvocationGraph from "../Workflow/Invocation/Graph/InvocationGraph.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import InvocationMessage from "@/components/WorkflowInvocationState/InvocationMessage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationOverview',
    props: {
        invocation: null,
        invocationAndJobTerminal: { type: Boolean },
        invocationSchedulingTerminal: { type: Boolean },
        isFullPage: { type: Boolean },
        jobStatesSummary: null,
        index: null,
        isSubworkflow: { type: Boolean }
    },
    emits: ["invocation-cancelled"],
    setup(__props, { emit }) {
        const props = __props;
        function getUrl(path) {
            return getRootFromIndexLink() + path;
        }
        const generatePdfTooltip = "Generate PDF report for this workflow invocation";
        const { workflow, loading, error } = useWorkflowInstance(props.invocation.workflow_id);
        const invocationId = computed(() => props.invocation.id);
        const indexStr = computed(() => {
            if (props.index == undefined) {
                return "";
            }
            else {
                return `${props.index + 1}`;
            }
        });
        const invocationState = computed(() => {
            return props.invocation.state || "new";
        });
        const invocationStateSuccess = computed(() => {
            return invocationState.value == "scheduled" && runningCount.value === 0 && props.invocationAndJobTerminal;
        });
        const disabledReportTooltip = computed(() => {
            const state = invocationState.value;
            const runCount = runningCount.value;
            if (state != "scheduled") {
                return `This workflow is not currently scheduled. The current state is ${state}. Once the workflow is fully scheduled and jobs have complete this option will become available.`;
            }
            else if (runCount != 0) {
                return `The workflow invocation still contains ${runCount} running job(s). Once these jobs have completed this option will become available.`;
            }
            else {
                return "Steps for this workflow are still running. A report will be available once complete.";
            }
        });
        const stepCount = computed(() => {
            return props.invocation.steps.length || 0;
        });
        const stepStates = computed(() => {
            const stepStates = {};
            const steps = props.invocation.steps || [];
            for (const step of steps) {
                if (!step) {
                    continue;
                }
                // the API defined state here allowing null and undefined is odd...
                const stepState = step.state || "unknown";
                if (!stepStates[stepState]) {
                    stepStates[stepState] = 1;
                }
                else {
                    stepStates[stepState] += 1;
                }
            }
            return stepStates;
        });
        const invocationPdfLink = computed(() => {
            const id = invocationId.value;
            if (id) {
                return getUrl(`api/invocations/${id}/report.pdf`);
            }
            else {
                return null;
            }
        });
        const uniqueMessages = computed(() => {
            const messages = props.invocation.messages || [];
            const uniqueMessagesSet = new Set(messages.map((message) => JSON.stringify(message)));
            return Array.from(uniqueMessagesSet).map((message) => JSON.parse(message));
        });
        const stepStatesStr = computed(() => {
            var _a;
            return `${((_a = stepStates.value) === null || _a === void 0 ? void 0 : _a.scheduled) || 0} of ${stepCount.value} steps successfully scheduled.`;
        });
        const okCount = computed(() => {
            return jobStatesSummaryOkCount(props.jobStatesSummary);
        });
        const runningCount = computed(() => {
            return jobStatesSummaryRunningCount(props.jobStatesSummary);
        });
        const jobCount = computed(() => {
            return jobStatesSummaryJobCount(props.jobStatesSummary);
        });
        const errorCount = computed(() => {
            return jobStatesSummaryErrorCount(props.jobStatesSummary);
        });
        const newCount = computed(() => {
            return jobCount.value - okCount.value - runningCount.value - errorCount.value;
        });
        const jobStatesStr = computed(() => {
            let jobStr = `${numTerminal(props.jobStatesSummary) || 0} of ${jobCount.value} jobs complete`;
            if (!props.invocationSchedulingTerminal) {
                jobStr += " (total number of jobs will change until all steps fully scheduled)";
            }
            return `${jobStr}.`;
        });
        function onCancel() {
            emit("invocation-cancelled");
        }
        return { __sfc: true, getUrl, props, generatePdfTooltip, workflow, loading, error, invocationId, indexStr, invocationState, invocationStateSuccess, disabledReportTooltip, stepCount, stepStates, invocationPdfLink, uniqueMessages, stepStatesStr, okCount, runningCount, jobCount, errorCount, newCount, jobStatesStr, emit, onCancel, BAlert, BButton, withPrefix, ExternalLink, HelpText, InvocationGraph, LoadingSpan, ProgressBar, InvocationMessage };
    }
});
